export default __webpack_public_path__ + "static/media/inout-text.c66fcd61.png";